import BaseFormProviderControl, {
    type IFormProviderControlProps as IBaseFormProviderControlProps,
} from '@srm/ui/controls/FormProviderControl';
import { ChangeHandlersProvider, type IChangeHandlersProviderProps } from '@controls/ChangeHandlers/ChangeHandlers';
import type { ChangeRuntime } from '@utils/managers/ChangeRuntime';
import type { IChangeAction } from '@models/Forms/IForms';

export interface IFormProviderControlProps
    extends IBaseFormProviderControlProps, Pick<IChangeHandlersProviderProps, 'deferChange' | 'onDeferredChange'> {
    changeRuntime?: ChangeRuntime;
    changeActions?: IChangeAction[];
}

/** Форма пакета со своей областью обработчиков `<changes>`: поля вложенной формы не регистрируются во внешней. */
const FormProviderControl = ({
    changeRuntime,
    changeActions,
    deferChange,
    onDeferredChange,
    ...props
}: IFormProviderControlProps) => (
    <ChangeHandlersProvider
        runtime={changeRuntime}
        changeActions={changeActions}
        deferChange={deferChange}
        onDeferredChange={onDeferredChange}
    >
        <BaseFormProviderControl {...props} />
    </ChangeHandlersProvider>
);

export default FormProviderControl;
